import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RechazosList from './RechazosList';
import { MdReceiptLong } from 'react-icons/md';

export default{
  icon: MdReceiptLong,
  list: RechazosList,
};